import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { NmSelectOption } from '../widgets/select/select';
import { NmReactiveSelectOption } from '../widgets/reactive-select/reactive-select';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import async from 'async-es';


/**
	Shared data for whole app
	store each massive data in local variable
	so as not to call api everytime the data is requested
*/

@Injectable()
export class SharedDataService {



	//hkaf
	public memberTypes: BehaviorSubject<NmSelectOption[]>;
	public memberStatusList: BehaviorSubject<NmSelectOption[]>;
	public memberGenders: BehaviorSubject<NmSelectOption[]>;
	public subDistricts: BehaviorSubject<NmSelectOption[]>;
	public volunteerTypes: BehaviorSubject<NmSelectOption[]>;
	public eduLevels: BehaviorSubject<NmSelectOption[]>;
	public schools: BehaviorSubject<NmSelectOption[]>;
	public interestTypes: BehaviorSubject<NmSelectOption[]>;
	public memberLangs: BehaviorSubject<NmSelectOption[]>;
	public memberImportStatus: BehaviorSubject<NmSelectOption[]>;
	public memberOptions: any [];
	public schoolCommonData: any [];
	public schoolStatus: BehaviorSubject<NmSelectOption[]>;
	public schoolNature: BehaviorSubject<NmSelectOption[]>;
	public schoolSecondaryNature: BehaviorSubject<NmSelectOption[]>;
	public schoolInterest: BehaviorSubject<NmSelectOption[]>;
	public schoolLangs: BehaviorSubject<NmSelectOption[]>;
	public schoolReceiveMethod: BehaviorSubject<NmSelectOption[]>;

	public constructor(
		private api: ApiService
	) {
		// variable initiation

		//hkaf
		this.memberTypes = new BehaviorSubject<NmSelectOption[]>([]);
		this.memberStatusList = new BehaviorSubject<NmSelectOption[]>([]);
		this.memberGenders = new BehaviorSubject<NmSelectOption[]>([]);
		this.subDistricts = new BehaviorSubject<NmSelectOption[]>([]);
		this.volunteerTypes = new BehaviorSubject<NmSelectOption[]>([]);
		this.eduLevels = new BehaviorSubject<NmSelectOption[]>([]);
		this.schools = new BehaviorSubject<NmSelectOption[]>([]);
		this.interestTypes = new BehaviorSubject<NmSelectOption[]>([]);
		this.memberLangs = new BehaviorSubject<NmSelectOption[]>([]);
		this.memberImportStatus = new BehaviorSubject<NmSelectOption[]>([]);
		this.memberOptions = [];
		this.schoolCommonData = [];
		this.schoolStatus = new BehaviorSubject<NmSelectOption[]>([]);
		this.schoolNature = new BehaviorSubject<NmSelectOption[]>([]);
		this.schoolSecondaryNature = new BehaviorSubject<NmSelectOption[]>([]);
		this.schoolInterest = new BehaviorSubject<NmSelectOption[]>([]);
		this.schoolLangs = new BehaviorSubject<NmSelectOption[]>([]);
		this.schoolReceiveMethod = new BehaviorSubject<NmSelectOption[]>([]);
	}

	// get data via api, expected called only when after login
	public initiate() {

		this._getCommonData();

	}


	// TODO: integrate with api
	// by ken's words, this should be done in one api with diff type
	private _getCommonData = () => {
		

		//hkaf
		// this._memberTypes();
		// this._memberStatusList();
		// this._memberGenders();
		// this._subDistricts();
		// this._eduLevels();
		// this._schools();
		// this._interestTypes();
		// this._memberLangs();
		this._memberCommonData();
		this._schoolCommonData();
	}
	//hkaf
	private _memberTypes = () => this.api.sendApiRequest('get', 'member/types').subscribe(res => {

		let types = res.json();
		let arr = [];
		for(let key in types) {
			arr.push({
				label: types[key].name,
				value: types[key].code
			});
		}
		this.memberOptions['memberTypes'] = arr;
		this.memberTypes.next(arr);
	});
	private _memberStatusList = () => this.api.sendApiRequest('get', 'member/statuslist').subscribe(res => {

		let types = res.json();
		let arr = [];
		for(let key in types) {
			arr.push({
				label: types[key].Name,
				value: types[key].Code
			});
		}
		this.memberOptions['memberStatusList'] = arr;
		this.memberStatusList.next(arr);

	});
	private _memberGenders = () => {
		let arr = [
			{ label: 'Male', value: 'M' },
			{ label: 'Female', value: 'F' },
			
		];
		this.memberOptions['memberGenders'] = arr;
		this.memberGenders.next(arr);

	};
	private _memberLangs = () => {
		let arr = [
			{ label: 'Chinese', value: 'zh' },
			{ label: 'English', value: 'en' },
			
		];
		this.memberOptions['memberLangss'] = arr;
		this.memberLangs.next(arr);

	};
	private _subDistricts = () => this.api.sendApiRequest('get', 'member/subdistricts').subscribe(res => {

		let types = res.json();
		let arr = [];
		for(let key in types) {
			arr.push({
				label: types[key].Subdistrict,
				value: types[key].Id
			});
		}
		this.memberOptions['memberSubDistricts'] = arr;
		this.subDistricts.next(arr);

	});
	private _eduLevels = () => this.api.sendApiRequest('get', 'member/edulevels').subscribe(res => {

		let types = res.json();
		let arr = [];
		for(let key in types) {
			arr.push({
				label: types[key].Name,
				value: types[key].Id
			});
		}
		this.memberOptions['memberEduLevels'] = arr;
		this.eduLevels.next(arr);

	});
	private _schools = () => this.api.sendApiRequest('get', 'member/schools').subscribe(res => {

		let types = res.json();
		let arr = [];
		for(let key in types) {
			arr.push({
				label: types[key].SchoolCompleteName,
				value: types[key].SchoolId
			});
		}
		this.memberOptions['schools'] = arr;
		this.schools.next(arr);

	});
	private _interestTypes = () => this.api.sendApiRequest('get', 'member/interesttypes').subscribe(res => {

		let types = res.json();
		let arr = [];
		for(let key in types) {
			arr.push({
				label: types[key].Name,
				value: types[key].Id
			});
		}
		this.memberOptions['interestTypes'] = arr;
		this.interestTypes.next(arr);

	});

	private _memberCommonData = () => this.api.sendApiRequest('get', 'member/commondata').subscribe(res => {

		let types = res.json();
		//console.log(types);
		let arr;
		let memberTypes = [];
		let memberStatusList = [];
		let memberGenders = [];
		let memberLangs = [];
		let memberSubDistricts = [];
		let volunteerTypes = [];
		let schools = [];
		let interestTypes = [];
		let memberEduLevels = [];
		let importStatus = [
			{
				label: 'New member',
				value: 'added'
			},
			{
				label: 'Old member',
				value: 'renewed'
			},
			{
				label: 'Manual match',
				value: 'pending'
			},
			{
				label: 'Ignored',
				value: 'ignored'
			}
		];
		for(let key in types['memberTypes']) {
			memberTypes.push({
				label: types['memberTypes'][key].name,
				value: types['memberTypes'][key].code
			});
		}
		for(let key in types['memberStatusList']) {
			memberStatusList.push({
				label: types['memberStatusList'][key].Name,
				value: types['memberStatusList'][key].Code
			});
		}
		for(let key in types['memberGenders']) {
			memberGenders.push({
				label: types['memberGenders'][key].label,
				value: types['memberGenders'][key].value
			});
		}
		for(let key in types['memberLangs']) {
			memberLangs.push({
				label: types['memberLangs'][key].name,
				value: types['memberLangs'][key].code
			});
		}
		for(let key in types['memberSubDistricts']) {
			memberSubDistricts.push({
				label: types['memberSubDistricts'][key].Subdistrict,
				value: types['memberSubDistricts'][key].Id
			});
		}
		for(let key in types['volunteerTypes']) {
			volunteerTypes.push({
				label: types['volunteerTypes'][key].title,
				value: types['volunteerTypes'][key].id
			});
		}
		for(let key in types['schools']) {
			schools.push({
				label: types['schools'][key].SchoolId+'. '+types['schools'][key].SchoolCompleteName,
				value: types['schools'][key].SchoolId
			});
		}
		for(let key in types['interestTypes']) {
			interestTypes.push({
				label: types['interestTypes'][key].Name,
				value: types['interestTypes'][key].Id
			});
		}
		for(let key in types['memberEduLevels']) {
			memberEduLevels.push({
				label: types['memberEduLevels'][key].Name,
				value: types['memberEduLevels'][key].Id
			});
		}
		this.memberOptions['memberTypes'] = memberTypes;
		this.memberOptions['memberStatusList'] = memberStatusList;
		this.memberOptions['memberGenders'] = memberGenders;
		this.memberOptions['memberLangs'] = memberLangs;
		this.memberOptions['memberSubDistricts'] = memberSubDistricts;
		this.memberOptions['volunteerTypes'] = volunteerTypes;
		this.memberOptions['schools'] = schools;
		this.memberOptions['interestTypes'] = interestTypes;
		this.memberOptions['memberEduLevels'] = memberEduLevels;
		this.memberOptions['importStatus'] = importStatus;
		this.memberOptions['membership_year'] = types.membership_year;
		this.memberTypes.next(memberTypes);
		this.memberStatusList.next(memberStatusList);
		this.memberGenders.next(memberGenders);
		this.memberLangs.next(memberLangs);
		this.subDistricts.next(memberSubDistricts);
		this.volunteerTypes.next(volunteerTypes);
		this.schools.next(schools);
		this.interestTypes.next(interestTypes);
		this.eduLevels.next(memberEduLevels);
		this.memberImportStatus.next(importStatus);
	});

	private _schoolCommonData = () => this.api.sendApiRequest('get', 'school/commondata').subscribe(res => {

		let types = res.json();
		//console.log(types);
		let arr;
		let statusList = [];
		let schoolNature = [];
		let secondaryNature = [];
		let schoolInterest = [];
		let langs = [];
		let receiveMethods = [];
		for(let key in types['statusList']) {
			statusList.push({
				label: types['statusList'][key].Name,
				value: types['statusList'][key].Code
			});
		}
		for(let key in types['schoolNature']) {
			schoolNature.push({
				label: types['schoolNature'][key].name,
				value: types['schoolNature'][key].code
			});
		}
		for(let key in types['secondaryNature']) {
			secondaryNature.push({
				label: types['secondaryNature'][key].name,
				value: types['secondaryNature'][key].code
			});
		}
		for(let key in types['schoolInterest']) {
			schoolInterest.push({
				label: types['schoolInterest'][key].Name,
				value: types['schoolInterest'][key].Id
			});
		}
		for(let key in types['langs']) {
			langs.push({
				label: types['langs'][key].name,
				value: types['langs'][key].code
			});
		}
		for(let key in types['receiveMethods']) {
			receiveMethods.push({
				label: types['receiveMethods'][key].name,
				value: types['receiveMethods'][key].code
			});
		}
		this.schoolCommonData['statusList'] = statusList;
		this.schoolCommonData['schoolNature'] = schoolNature;
		this.schoolCommonData['secondaryNature'] = secondaryNature;
		this.schoolCommonData['schoolInterest'] = schoolInterest;
		this.schoolCommonData['langs'] = langs;
		this.schoolCommonData['receiveMethods'] = receiveMethods;
		this.schoolStatus.next(statusList);
		this.schoolNature.next(schoolNature);
		this.schoolSecondaryNature.next(secondaryNature);
		this.schoolInterest.next(schoolInterest);
		this.schoolLangs.next(langs);
		this.schoolReceiveMethod.next(receiveMethods);
	});

	public makeId(len: number = 10) {
	  let text = "";
	  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

	  for (let i = 0; i < len; i++)
	    text += possible.charAt(Math.floor(Math.random() * possible.length));

	  return text;
	}

}


// WEBPACK FOOTER //
// ./src/services/data.shared.service.ts